'use strict';

var GridSelectionExampleDirective = function GridSelectionExampleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-selection-example.html'),
    controller: 'GridSelectionExampleController',
    scope: {
      data: '='
    }
  };
};
GridSelectionExampleDirective.$inject = [];
module.exports = GridSelectionExampleDirective;